import { render, staticRenderFns } from "./wallet.vue?vue&type=template&id=25035577&"
import script from "./wallet.vue?vue&type=script&lang=js&"
export * from "./wallet.vue?vue&type=script&lang=js&"
import style0 from "./wallet.vue?vue&type=style&index=0&id=25035577&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports